import { RocketOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { useState } from 'react';
import { createCheckoutSession } from 'services/api/users';
import posthog from 'posthog-js';
import styles from 'styles/components/onboarding.module.scss';
import {
  LOCAL_STORAGE,
  SESSION_PENDING_PRO_CHECKOUT,
} from 'utils/constants';

const ChoosePlan = ({ nextStep }) => {
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  const markDone = () => {
    localStorage.setItem(LOCAL_STORAGE.PLAN_STEP_DONE, '1');
  };

  const continueFree = () => {
    posthog.capture('plan_selected', { plan: 'free' });
    markDone();
    nextStep();
  };

  const startCheckout = async () => {
    posthog.capture('plan_selected', { plan: 'pro' });
    setCheckoutLoading(true);
    try {
      // Returns to onboarding at the LinkedIn step (or here if canceled).
      const { data } = await createCheckoutSession({ returnTo: 'onboarding' });
      markDone();
      sessionStorage.setItem(SESSION_PENDING_PRO_CHECKOUT, '1');
      window.location.href = data.url;
    } catch (err) {
      message.error('Could not start checkout. Please try again.');
      setCheckoutLoading(false);
    }
  };

  return (
    <div>
      <h1 className={styles.title}>Choose your plan</h1>
      <div className={styles.subtitle}>
        Start free, or get more out of KarmaLinks with Pro.
      </div>
      <div className={styles.planGrid}>
        <div className={styles.planCard}>
          <div className={styles.planPrice}>Free</div>
          <div className={styles.planName}>KarmaLinks Membership</div>
          <ul>
            <li>KarmaPoints earned by giving backlinks</li>
            <li>2 backlink requests at a time</li>
            <li>Backlink monitoring</li>
          </ul>
          <Button block size="large" onClick={continueFree}>
            Continue with Free
          </Button>
        </div>
        <div className={`${styles.planCard} ${styles.planCardPro}`}>
          <div className={styles.planPrice}>$19/month</div>
          <div className={styles.planName}>KarmaLinks Pro</div>
          <ul>
            <li>200 KarmaPoints every month</li>
            <li>5 backlink requests at a time</li>
            <li>Request from every domain</li>
          </ul>
          <Button
            block
            size="large"
            type="primary"
            icon={<RocketOutlined />}
            loading={checkoutLoading}
            onClick={startCheckout}
          >
            Upgrade to Pro
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChoosePlan;
